import gql from 'graphql-tag'

export const companyUpdateContactEmailTemplate = gql`
  mutation companyUpdateContactEmailTemplate($input: CompanyUpdateContactEmailTemplateInput!) {
    companyUpdateContactEmailTemplate(input: $input) {
      success
    }
  }
`
